// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.accountview.properties.RentalManagerAccountViewZramMultifamilyWebApiHandler

import { frontEndRequestV2 } from '@zg-rentals/ts-client-fetch';
import type { RentalManagerEnvironment } from '@zg-rentals/rental-manager-env-base';

import type {
  AccountViewListingAdvertisingDto,
  AccountViewListingOptionsDto,
  AccountViewListingProspectsDto,
  AccountViewListingQualityScoreDto,
  AccountViewListingsDto,
  AccountViewListingSourcesDto,
  AccountViewListingStatusOverviewDto,
  ListingAlias,
  RentalManagerListingFieldSortType,
} from '../..';

interface AdvertisingParams {
  listingAlias: ListingAlias;
}
interface ListParams {
  ascending?: boolean;
  includeActive?: boolean;
  includeArchived?: boolean;
  includeAtRiskOnly?: boolean;
  includeFreeBonusListingsOnly?: boolean;
  includeFreeClaimedListingsOnly?: boolean;
  includeInactive?: boolean;
  includeListingCounts?: boolean;
  includeUnarchived?: boolean;
  limit?: number;
  offset?: number;
  searchText?: string;
  sort?: RentalManagerListingFieldSortType;
  startKeyExclusive?: string;
}
interface ListingQualityScoreParams {
  listingAlias: ListingAlias;
}
interface OptionsParams {
  listingAlias: ListingAlias;
}
interface ProspectsParams {
  listingAlias: ListingAlias;
}
interface SourcesParams {
  listingAlias: ListingAlias;
}
interface StatusParams {
  listingAlias: ListingAlias;
}

export const RentalManagerAccountViewZramMultifamilyWebApiHandler_advertising_Path =
  '/api/web/v1/users/accountView/zram/multifamily/properties/advertising';

/**
 * Get multifamily customer account view property listing advertising
 */
export const RentalManagerAccountViewZramMultifamilyWebApiHandler_advertising = (
  getParams: AdvertisingParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<AdvertisingParams, never, AccountViewListingAdvertisingDto>({
    getParams: getParams,
    endpoint: RentalManagerAccountViewZramMultifamilyWebApiHandler_advertising_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerAccountViewZramMultifamilyWebApiHandler_list_Path =
  '/api/web/v1/users/accountView/zram/multifamily/properties/list';

/**
 * Get multifamily customer account view property list
 */
export const RentalManagerAccountViewZramMultifamilyWebApiHandler_list = (
  getParams: ListParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<ListParams, never, AccountViewListingsDto>({
    getParams: getParams,
    endpoint: RentalManagerAccountViewZramMultifamilyWebApiHandler_list_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerAccountViewZramMultifamilyWebApiHandler_listingQualityScore_Path =
  '/api/web/v1/users/accountView/zram/multifamily/properties/listingQualityScore';

/**
 * Get multifamily customer account view property listing quality score
 */
export const RentalManagerAccountViewZramMultifamilyWebApiHandler_listingQualityScore = (
  getParams: ListingQualityScoreParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<ListingQualityScoreParams, never, AccountViewListingQualityScoreDto>({
    getParams: getParams,
    endpoint: RentalManagerAccountViewZramMultifamilyWebApiHandler_listingQualityScore_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerAccountViewZramMultifamilyWebApiHandler_options_Path =
  '/api/web/v1/users/accountView/zram/multifamily/properties/options';

/**
 * Get multifamily customer account view property listing options
 */
export const RentalManagerAccountViewZramMultifamilyWebApiHandler_options = (
  getParams: OptionsParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<OptionsParams, never, AccountViewListingOptionsDto>({
    getParams: getParams,
    endpoint: RentalManagerAccountViewZramMultifamilyWebApiHandler_options_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerAccountViewZramMultifamilyWebApiHandler_prospects_Path =
  '/api/web/v1/users/accountView/zram/multifamily/properties/prospects';

/**
 * Get multifamily customer account view property prospects
 */
export const RentalManagerAccountViewZramMultifamilyWebApiHandler_prospects = (
  getParams: ProspectsParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<ProspectsParams, never, AccountViewListingProspectsDto>({
    getParams: getParams,
    endpoint: RentalManagerAccountViewZramMultifamilyWebApiHandler_prospects_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerAccountViewZramMultifamilyWebApiHandler_sources_Path =
  '/api/web/v1/users/accountView/zram/multifamily/properties/sources';

/**
 * Get multifamily customer account view property listing sources
 */
export const RentalManagerAccountViewZramMultifamilyWebApiHandler_sources = (
  getParams: SourcesParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<SourcesParams, never, AccountViewListingSourcesDto>({
    getParams: getParams,
    endpoint: RentalManagerAccountViewZramMultifamilyWebApiHandler_sources_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerAccountViewZramMultifamilyWebApiHandler_status_Path =
  '/api/web/v1/users/accountView/zram/multifamily/properties/status';

/**
 * Get multifamily customer account view property listing status
 */
export const RentalManagerAccountViewZramMultifamilyWebApiHandler_status = (
  getParams: StatusParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<StatusParams, never, AccountViewListingStatusOverviewDto>({
    getParams: getParams,
    endpoint: RentalManagerAccountViewZramMultifamilyWebApiHandler_status_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};
